import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface GetServiceFeeProps extends CacheProps {
  userId: string
  subTypeId: string
  contactId: string
}

const getServiceFee = ({ contactId, subTypeId, userId, ...rest }: GetServiceFeeProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.appointment.service-fee'],
    payload: {
      user_id: userId,
      sub_type_id: subTypeId,
      contact_id: contactId,
    },
    ...rest,
  });
};

export default getServiceFee;
